<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "CustomerTripOrdersIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
